export const indexEntries = [
  {
    id: 'idx-01',
    no: '01',
    tag: '同类',
    title: '同类站点都在讨论什么',
    summary: '先把「同类」这个词拆开：有的是版面结构相似，有的是内容方向相似，还有的只是名字接近，看清属于哪一种再谈对比。',
  },
  {
    id: 'idx-02',
    no: '02',
    tag: '索引',
    title: '索引清晰的站点更好上手',
    summary: '合集与索引是否醒目，决定了新访客第一次进入时能不能快速找到方向，这一步往往比内容量更影响体验。',
  },
  {
    id: 'idx-03',
    no: '03',
    tag: '节奏',
    title: '更新节奏决定逛的体感',
    summary: '更新太密会显得杂，太慢又容易空，留意它的更新节奏和你自己习惯的浏览频率是否合拍。',
  },
  {
    id: 'idx-04',
    no: '04',
    tag: '平替',
    title: '平替不等于一模一样',
    summary: '所谓的黑料网站平替，通常是核心体验接近、但排版与侧重不同的那一种，接受差异才能换得顺利。',
  },
  {
    id: 'idx-05',
    no: '05',
    tag: '氛围',
    title: '社区讨论氛围是软指标',
    summary: '页面干净、线条克制、讨论区安静有序的站点，往往比花哨的更容易待得久，这点很难靠参数说明。',
  },
  {
    id: 'idx-06',
    no: '06',
    tag: '试错',
    title: '把试错成本压到最低',
    summary: '换一家之前先给自己列三条必须满足的条件，达不到就直接排除，避免在相似站点之间来回打转。',
  },
];

export const dimensions = [
  {
    id: 'dim-structure',
    icon: 'ri-layout-masonry-line',
    title: '结构：它是怎么组织内容的',
    summary: '先看首页是列表流、还是合集索引、还是分区陈列，结构决定了你怎么逛，也决定了找东西快不快。',
  },
  {
    id: 'dim-index',
    icon: 'ri-list-check-2',
    title: '索引：找东西是不是顺手',
    summary: '索引与合集是否醒目、分类是否自洽，是判断一个黑料网站同类站点值不值得留的首要指标。',
  },
  {
    id: 'dim-rhythm',
    icon: 'ri-time-line',
    title: '节奏：更新与留白',
    summary: '留白多、节奏慢的站点适合慢慢看；更新频密的适合快速刷。两者没有高下，只有合不合你。',
  },
  {
    id: 'dim-tone',
    icon: 'ri-chat-smile-2-line',
    title: '氛围：社区讨论的温度',
    summary: '讨论区安静还是热闹、回复是否克制，直接塑造一个站点的气质，也影响你愿不愿意久留。',
  },
  {
    id: 'dim-read',
    icon: 'ri-font-size-2',
    title: '阅读：标题与摘要的取舍',
    summary: '标题优先还是配图优先，会带来完全不同的浏览手感，喜欢快速扫读的人更看重前者。',
  },
  {
    id: 'dim-shell',
    icon: 'ri-window-line',
    title: '外壳：干净还是堆砌',
    summary: '干净轻壳、线条克制的站点，长期看更耐看；层层嵌套的壳子则容易让人疲劳。',
  },
];

export const digestList = [
  {
    id: 'dg-1',
    label: '同类',
    title: '名字相近但方向不同的一类',
    summary: '看上去像黑料网站同类，实际重点放在索引整理而非讨论，适合先逛再决定。',
  },
  {
    id: 'dg-2',
    label: '平替',
    title: '核心体验接近、侧重略偏的一类',
    summary: '黑料网站平替的关键在「接近」二字，先在它身上验证自己的浏览习惯是否成立。',
  },
  {
    id: 'dg-3',
    label: '相似',
    title: '版式相似但社区气质不同的一类',
    summary: '黑料网站相似更多指观感相近，讨论氛围却可能完全不同，别被首页骗过去。',
  },
  {
    id: 'dg-4',
    label: '对比',
    title: '把差别摆在明面上的那一类',
    summary: '愿意做黑料网站对比的站点通常结构更清楚，先看它怎么分类，再判断合不合用。',
  },
  {
    id: 'dg-5',
    label: '新选择',
    title: '节奏更新、更适合第一次接触的一类',
    summary: '把黑料网站新选择当作起点而不是终点，先用一周，再决定要不要换一家。',
  },
];

export const guideSteps = [
  {
    id: 'step-1',
    no: '一',
    title: '先定三条硬条件',
    summary: '例如「要有清晰索引」「更新不过密」「讨论区安静」，三条不满足两条就直接略过。',
  },
  {
    id: 'step-2',
    no: '二',
    title: '同一周内横向看成几家',
    summary: '把候选的相似站点放在同一时间段里逛一遍，差别会更明显，记忆也更准确。',
  },
  {
    id: 'step-3',
    no: '三',
    title: '优先选索引醒目的那家',
    summary: '索引清楚意味着之后的每次回访都省力，这是长期使用里回报最高的一项。',
  },
  {
    id: 'step-4',
    no: '四',
    title: '留一个备选再决定',
    summary: '哪怕已经选定了黑料网站新选择，也留一个同类备选，临时想换一家时不用重新开始找。',
  },
];

export const checklist = [
  { id: 'ck-1', text: '它是否属于我真正需要的「同类」，而不是名字接近' },
  { id: 'ck-2', text: '首页的索引与合集是否一眼能看懂' },
  { id: 'ck-3', text: '更新节奏与我的浏览频率是否合拍' },
  { id: 'ck-4', text: '讨论氛围是否安静、有秩序' },
  { id: 'ck-5', text: '阅读方式是否偏向标题优先' },
  { id: 'ck-6', text: '是否已经准备好一个备选，方便随时换一家' },
];

export const faqs = [
  {
    id: 'faq-1',
    q: '黑料网站同类和黑料网站平替，到底有什么区别？',
    a: '同类通常指方向与形态接近的站点，平替则更强调核心体验相近但侧重不同。简单说，同类看的是「像不像」，平替看的是「够不够用」。',
  },
  {
    id: 'faq-2',
    q: '想找黑料网站相似站点，应该先看哪一项？',
    a: '先看索引与合集是否醒目。相似只是观感层面的接近，真正决定你能不能长期用的是结构是否清楚、找东西是否顺手。',
  },
  {
    id: 'faq-3',
    q: '做黑料网站对比时，最容易忽略的是什么？',
    a: '最容易忽略的是节奏与氛围这类软指标。很多人只对比内容量，结果换一家之后发现更新太密或太安静，反而待不住。',
  },
  {
    id: 'faq-4',
    q: '换了新选择之后还是不习惯，要马上再换吗？',
    a: '建议先用满一周。新选择的差异往往在第二、三次回访时才显现，过早再换容易陷入来回试错的循环。',
  },
  {
    id: 'faq-5',
    q: '同时保留几个相似站点会比较合适？',
    a: '一个主用加一个备选就够了。保留太多会分散注意力，也让你更难判断到底是哪一家的差别在起作用。',
  },
];

export const statItems = [
  { id: 'st-1', value: '6', unit: '类', label: '可感知的差别维度' },
  { id: 'st-2', value: '3', unit: '条', label: '换一家前的硬条件' },
  { id: 'st-3', value: '7', unit: '天', label: '新选择的建议试用期' },
];